<template>
  <div class="tip-wrap">
    <div class="card">
      <div class="card-content">
        <div class="salutation">亲爱的伙伴:</div>
        <div class="text">
          {{text}}
        </div>
      </div>
    </div>
    <div class="content">
      <div class="title">{{title}}</div>
      <div class="qr-code-wrap">
        <img src="../assets/imgs/salarybill-icon.png">
        <div>用友工资条</div>
        <div>1分钟发布工资条</div>
        <div></div>
        <div>官方服务群</div>
        <img :src="src" class="qr-code">
        <div class="desc">长按扫码，加入用友工资条大家庭</div>
      </div>
      <div class="footer">
        <div>专属客服答疑</div>
        <div>新功能试用资格</div>
        <div>专业功能介绍</div>
        <div>不定期奖励活动</div>
        <div class="foot">
          客服电话：400-612-3330（工作日9:00-18:00）
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'tip',
    data() {
      return {
        type: '',
        text1: '感谢您在众多的人力资源产品中,选择了《用友工资条》企业微信版!\n' +
          '我们的成长,得益于6万家客户的选择、挑剔与帮助,也得益于深度客户的介绍与推广。',
        text2: '您安装用友工资条后一直没有使用，我们很忐忑，如果是使用问题，进群！我们竭诚为您服务！',
        text3: '您的工资条体验资格即将到期，进群咨询体验期延长方式，了解最新折扣，我们等您！',
        title1: '进群领「邀请码」体验新功能',
        title2: '进群领「邀请码」体验新功能',
        title3: '进群获得工资条最新折扣资讯'
      }
    },
    computed: {
      text() {
        return this.type ? this[`text${this.type}`] : ''
      },
      title() {
        return this.type ? this[`title${this.type}`] : ''
      },
      src() {
        return this.type ? require(`../assets/imgs/group-${this.type}.jpg`) : ''
      }
    },
    created() {
      this.type = this.$route.query.type
      document.title = '专属客服群'
    }
  }
</script>

<style scoped lang="stylus">
  @import '../assets/css/mixins.styl'
  .tip-wrap
    min-height 100vh
    overflow hidden
    background #fff
    .card
      background-color #3975C6
      overflow-x hidden
      position relative
      .card-content
        width 686px
        height 323px
        border-radius 12px 12px 0px 0px
        background-color #fff
        margin 36px auto 0
        overflow-x hidden
        padding 0 28px 0 40px
        box-sizing border-box
        font-size 32px
        color #666
        position relative
        &:after
          content ''
          height 44px
          background:linear-gradient(180deg,rgba(211,229,247,0) 0%,rgba(209,227,246,0.82) 100%)
          absolute left 0 bottom 0
          width 100%
        .salutation
          font-weight bold
          line-height 46px
          margin 30px auto 0 0
        .text
          margin-top 20px
          line-height 50px
          white-space pre-line
    .content
      user-select none
      position relative
      overflow-x hidden
      .title
        user-select none
        margin-top 50px
        font-size 36px
        line-height 38px
        text-align center
      .qr-code-wrap
        user-select none
        width 654px
        height 715px
        box-sizing border-box
        margin 50px auto 0
        border 1px solid #E5E5E5
        border-radius 8px
        position relative
        img
          user-select none
          width 70px
          absolute top 52px left 107px
          -webkit-tap-highlight-color rgba(0,0,0,0)
        div:nth-of-type(1)
          font-size 28px
          color #111
          line-height 37px
          absolute top 52px left 200px
        div:nth-of-type(2)
          font-size 20px
          color #555
          line-height 26px
          absolute top 95px left 196px
        div:nth-of-type(3)
          width 1px
          height 42px
          background-color #111
          absolute top 66px left 368px
        div:nth-of-type(4)
          font-size 32px
          color #111
          line-height 33px
          absolute top 69px left 388px
        .qr-code
          width 460px
          absolute top 147px left 97px
        .desc
          line-height 33px
          font-size 30px
          absolute bottom 50px left 102px
      .footer
        height 360px
        position relative
        font-size 28px
        line-height 37px
        div:nth-child(1)
          absolute top 50px left 163px
        div:nth-child(2)
          absolute top 50px left 409px
        div:nth-child(3)
          absolute top 117px left 162px
        div:nth-child(4)
          absolute top 117px left 409px
        div:not([class]):after
          content ''
          width 8px
          height @width
          background-color #000
          border-radius 50%
          absolute left -18px top 15px
        .foot
          line-height 28px
          color #555
          font-size 28px
          absolute bottom 99px left 0 right 0
          text-align center
</style>
